import { useSearchParams } from 'react-router-dom'
import { MigrationLayout } from '../../components/MigrationLayout'
import { getPartnerDisplayName } from '../../utils/migrationApi'
import { config } from '../../config'

export function LinkSuccessPage() {
  const [searchParams] = useSearchParams()
  const partner = searchParams.get('partner') || 'swgemu'
  const partnerDisplayName = getPartnerDisplayName(partner)

  const handleGoToLogin = () => {
    window.location.href = `${config.apiUrl}/auth/login`
  }

  return (
    <MigrationLayout>
      <div className="auth-page">
        <div className="auth-content">
          <div className="auth-card">
            <div style={{ fontSize: '3rem', marginBottom: '20px' }}>✅</div>
            <h1 style={{ color: '#28a745' }}>Great! Your account has been created</h1>
            <p>Your {partnerDisplayName} account is now linked to SWGRealms</p>

            <div className="auth-explanation">
              <h3>What's Next?</h3>
              
              <div className="step-list">
                <div className="step-item">
                  <div className="step-number">1</div>
                  <div className="step-content">
                    <strong>Check your email</strong> for a message from SWGRealms to set your password.
                    <div className="step-note">This usually arrives within a few minutes.</div>
                  </div>
                </div>

                <div className="step-item">
                  <div className="step-number">2</div>
                  <div className="step-content">
                    <strong>Set your password</strong> by clicking the link in the email.
                  </div>
                </div>

                <div className="step-item">
                  <div className="step-number">3</div>
                  <div className="step-content">
                    <strong>Sign in</strong> and start your galactic adventures!
                  </div>
                </div>
              </div>

              <div className="auth-note">
                <strong>Don't see the email?</strong> Check your spam folder or wait a few more minutes. 
                If you still don't receive it, contact support.
              </div>
            </div>

            <button
              className="auth-action-btn primary"
              onClick={handleGoToLogin}
            >
              Go to Login
            </button>
          </div>
        </div>
      </div>

      <style>{`
        .auth-page {
          position: relative;
          min-height: calc(100vh - 80px);
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          background: url('/swg_login_4x3.png') no-repeat center center fixed;
          background-size: cover;
          background-color: #000;
        }

        .auth-page::before {
          content: '';
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.4);
          z-index: 1;
        }

        .auth-content {
          text-align: center;
          z-index: 10;
          position: relative;
        }

        .auth-card {
          background: rgba(10, 25, 47, 0.85);
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          border: 1px solid rgba(0, 212, 255, 0.3);
          border-radius: 12px;
          padding: 48px 40px;
          box-shadow: 
            0 8px 32px rgba(0, 0, 0, 0.37),
            inset 0 0 20px rgba(0, 212, 255, 0.1);
          max-width: 600px;
        }

        .auth-card h1 {
          color: #ffffff;
          margin-bottom: 8px;
          font-size: 28px;
          font-weight: 300;
        }

        .auth-card p {
          color: rgba(255, 255, 255, 0.7);
          margin-bottom: 32px;
          font-size: 16px;
        }

        .auth-explanation {
          text-align: left;
          margin-bottom: 32px;
          padding: 24px;
          background: rgba(0, 0, 0, 0.3);
          border-radius: 8px;
          border: 1px solid rgba(0, 212, 255, 0.2);
        }

        .auth-explanation h3 {
          color: rgba(255, 255, 255, 0.9);
          margin-top: 0;
          margin-bottom: 24px;
          font-size: 18px;
          font-weight: 500;
          text-align: center;
        }

        .step-list {
          margin-bottom: 24px;
        }

        .step-item {
          display: flex;
          align-items: flex-start;
          gap: 16px;
          margin-bottom: 20px;
          padding: 12px 16px;
          background: rgba(0, 0, 0, 0.2);
          border-radius: 6px;
          border: 1px solid rgba(0, 212, 255, 0.1);
          transition: all 0.3s ease;
        }

        .step-item:hover {
          border-color: rgba(0, 212, 255, 0.3);
          background: rgba(0, 0, 0, 0.3);
        }

        .step-number {
          background: linear-gradient(135deg, #00a8cc 0%, #0088cc 100%);
          color: #ffffff;
          border-radius: 50%;
          width: 28px;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          font-weight: 500;
          flex-shrink: 0;
          box-shadow: 0 2px 8px rgba(0, 168, 204, 0.3);
        }

        .step-content {
          color: rgba(255, 255, 255, 0.8);
          flex: 1;
        }

        .step-content strong {
          color: #00d4ff;
          font-weight: 500;
        }

        .step-note {
          font-size: 14px;
          opacity: 0.7;
          margin-top: 6px;
          color: rgba(255, 255, 255, 0.6);
        }

        .auth-note {
          background: rgba(0, 212, 255, 0.1);
          border-left: 3px solid #00d4ff;
          padding: 16px;
          border-radius: 6px;
          color: rgba(255, 255, 255, 0.8);
          font-size: 14px;
          line-height: 1.5;
        }

        .auth-note strong {
          color: #00d4ff;
          font-weight: 500;
        }

        .auth-action-btn {
          background: linear-gradient(135deg, #00a8cc 0%, #0088cc 100%);
          color: #ffffff;
          border: none;
          padding: 14px 24px;
          font-size: 16px;
          font-weight: 500;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.3s ease;
          display: block;
          width: 100%;
        }

        .auth-action-btn:hover {
          background: linear-gradient(135deg, #00b8dc 0%, #0098dc 100%);
          box-shadow: 0 4px 15px rgba(0, 168, 204, 0.3);
        }

        @media (max-width: 768px) {
          .auth-card {
            margin: 0 20px;
            padding: 32px 24px;
            max-width: none;
          }
          
          .auth-card h1 {
            font-size: 24px;
          }
          
          .auth-explanation {
            padding: 20px;
          }

          .step-item {
            padding: 12px;
          }

          .step-number {
            width: 24px;
            height: 24px;
            font-size: 12px;
          }
        }
      `}</style>
    </MigrationLayout>
  )
}
